<template>
  <div
    v-if="isVisible"
    class="absolute inset-0"
  >
    <div
      class="absolute inset-0 bg-[rgba(0,0,0,0.4)] z-[996]"
      style="backdrop-filter: blur(5px);"
    />
    <div class="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] bg-white rounded-[8px] p-[24px] w-[90%] sm:w-[500px] z-[1010] shadow-lg">
      <div>
        <div class="flex justify-center">
          <img
            src="https://storage.googleapis.com/komerce/assets/svg/Icon-Error.svg"
            alt="warning"
          >
        </div>
        <div class="mt-[24px] text-center text-[24px] font-semibold text-[#333333]">
          Akses Komcards Ditangguhkan
        </div>
        <div class="mt-[16px] text-center text-[#626262]">
          Akses kamu ke produk ini sementara ditangguhkan karena Komcards Skor berada di bawah batas minimum. Tingkatkan skor untuk membuka kembali akses.
        </div>
        <div class="mt-[16px] flex justify-center">
          <a
            :href="helpdesk"
            target="_blank"
            class="text-[#08A0F7] hover:text-[#08A0F7]"
          >
            Panduan Komcards Score
          </a>
        </div>
        <div class="flex justify-center mt-[24px]">
          <BButton
            variant="primary"
            class="w-full"
            @click="callCs()"
          >
            Hubungi CS
          </BButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
      helpdesk: process.env.VUE_APP_HELP_KOMCARDS_SCORE,
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(newVal) {
        this.isVisible = newVal
      },
    },
    isVisible(newVal) {
      if (newVal) {
        document.body.classList.add('overflow-hidden')
      } else {
        document.body.classList.remove('overflow-hidden')
      }
    },
  },
  beforeDestroy() {
    document.body.classList.remove('overflow-hidden')
  },
  methods: {
    show() {
      this.isVisible = true
    },
    hide() {
      this.isVisible = false
    },
    callCs() {
      this.$router.push('/')
      this.hide()
      setTimeout(() => {
        window.$crisp.push(['do', 'chat:open'])
      }, 1000)
    },
  },
}
</script>

<style scoped>
</style>
